var _path, _path2, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _circle4, _rect8, _rect9, _rect10, _circle5, _path3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _circle6, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e6cbf81b-57bf-4ada-93b6-52a7c690b584",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 863.41339,
    height: 594.50334,
    viewBox: "0 0 863.41339 594.50334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.45783,717.83874c-14.53694,10.27106-19.05685,28.8792-19.05685,28.8792s19.04911,1.95548,33.58605-8.3156,19.05685-28.8792,19.05685-28.8792S224.99478,707.56771,210.45783,717.83874Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.27318,722.9831c-7.27473,16.24487-24.66192,24.26857-24.66192,24.26857s-5.59248-18.3144,1.68226-34.55926,24.66187-24.26857,24.66187-24.26857S223.54791,706.73824,216.27318,722.9831Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 399.32024,
    y: 0.2631,
    width: 464.09314,
    height: 297.2259,
    fill: "#e5e5e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 412.59088,
    y: 37.54264,
    width: 437.55191,
    height: 113.30501,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 412.59088,
    y: 166.58445,
    width: 437.55191,
    height: 113.30501,
    fill: "#6c63ff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 399.12208,
    width: 464.09315,
    height: 19.71638,
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 413.7737,
    cy: 10.08006,
    r: 3.65428,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.64443,
    cy: 10.08006,
    r: 3.65428,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.51516,
    cy: 10.08006,
    r: 3.65428,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 566.42449,
    y: 73.15076,
    width: 146.29193,
    height: 6.91668,
    fill: "#cbcbcb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 566.42449,
    y: 91.13411,
    width: 146.29193,
    height: 6.91668,
    fill: "#cbcbcb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 566.42449,
    y: 109.11747,
    width: 146.29193,
    height: 6.91668,
    fill: "#cbcbcb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.53121,
    cy: 76.87011,
    r: 4.51397,
    fill: "#cbcbcb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 558.22087,
    y: 201.79526,
    width: 146.29193,
    height: 6.91668,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 558.22087,
    y: 219.77861,
    width: 146.29193,
    height: 6.91668,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 558.22087,
    y: 237.76197,
    width: 146.29193,
    height: 6.91668,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.91844,
    cy: 204.18202,
    r: 4.51397,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.4313,506.48113l-14.34912-64.57172-3.26709-24.89294-24.271,2.02252,2.48925,34.69458L356.508,512.71105a10.99976,10.99976,0,1,0,13.92334-6.22992Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#9f616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "237.4 581.782 249.659 581.782 255.492 534.494 237.397 534.495 237.4 581.782",
    fill: "#9f616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.56563,730.528l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38623v.5l-39.53076.00147Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.175 572.735 149.014 575.919 166.931 531.77 149.457 527.07 137.175 572.735",
    fill: "#9f616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303.48809,720.8052l23.31536,6.27127.00094.00025a15.38729,15.38729,0,0,1,10.86113,18.85512l-.12989.48284-38.17393-10.268Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M425.313,527.23383l5.43483,9.40127s5.97177,1.63112,4.02008,21.0977-11.628,67.62682-11.628,67.62682,9.59218,67.174.14512,81.36615l-1.70918,12.18705-17.83956,1.70477-.44982-10.81355s-12.90624-49.68326-10.66569-71.39811L382.015,559.56986s-22.50328,57.63582-29.40858,68.56623c0,0-11.536,67.07569-21.89975,70.68446l-3.74288,12.28726-18.781-2.73068,3.39724-14.11s.18516-65.912,15.51628-84.77869l11.84624-83.77832Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M395.30362,540.9016c-8.33155,0-16.07154-1.22656-20.59009-4.895-6.55591-5.32226-14.91321-4.1958-22.28662-3.20166-7.38623.99561-13.76526,1.855-16.14575-4.18066l-.042-.10645.00843-.11426,7.35547-98.562-9.7638-34.08105.02454-.12012c.03479-.16992,3.65613-17.04248,19.59143-25.00977l21.47827-9.85986,34.82324,2.86817,21.846,17.31152v.2417l.06152,154.62988-.376.09668C430.12491,536.217,411.58536,540.9016,395.30362,540.9016Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M348.61172,428.78978l-22.40649-7.16406,8.13721-28.34814,11.57836,1.27685Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#cbcbcb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M453.4313,522.48113l-14.34912-64.57172-3.26709-24.89294-24.271,2.02252,2.48925,34.69458L439.508,528.71105a10.99976,10.99976,0,1,0,13.92334-6.22992Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#9f616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.20425,439.22l-1.906-25.416,24.14624-33.4746.24462-.00831c.09961-.00537,9.812-.17334,11.56128,14.70557,1.70533,14.5044-3.509,41.47559-3.562,41.74609l-.07348.377Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#cbcbcb"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.37087,
    cy: 331.10476,
    r: 22.79337,
    transform: "translate(-216.22516 -85.14155) rotate(-9.21747)",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.20891,327.72112s.18248-8.013,1.1956-11.55868,3.03911-6.58475,2.0261-6.58475-1.51956-2.5326-1.51956-2.5326-1.013-.50651-1.51956,0-1.013-3.54562-1.013-3.54562-.50653-1.51955-1.013-.50651-.50654.50651-1.013-1.013-3.03927-2.53261-3.03927-2.53261-9.62386.50651-11.14342-1.51956-18.7412-.50652-22.28684,2.02607-19.24774,11.64994-16.71511,19.24773,9.823,25.09158,11.65,26.84552c2.88893,2.77348,4.88893,3.77348,18.55866,6.49349,2.67524.53232,16.33027-8.20046,16.33027-9.72s-1.64622-6.33845,1-7c4-1,4.45,4.057,5.46306,2.53748S416.20891,327.72112,416.20891,327.72112Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M550.29331,746.82055h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-168.29331 -152.74833)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.b0ec3b69271f20ef8cf16618b9130cae.svg";
export { ForwardRef as ReactComponent };